import { useQuery } from '@tanstack/react-query'
import { API_URL } from '../const'
import { ConfigurationText, Regione } from '../types'
import axios from 'axios'
import { serializeQueryParams } from './utils'

export async function getConfigTexts(
  params: Record<string, any> = {},
  signal?: AbortSignal
) {
  return (
    await axios.get(`${API_URL}/configuration-texts/`, {
      signal,
      params: serializeQueryParams(params),
    })
  ).data as ConfigurationText[]
}

export function useConfigTexts(
  params: Record<string, any> = {}
) {
  return useQuery({
    queryKey: ['configTexts', params],
    queryFn: ({ signal }) => getConfigTexts(params, signal),
    keepPreviousData: true,
    suspense: false,
  })
}

